import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const http = axios.create({ baseURL: API, withCredentials: true });

// Auth token lives in a secure httpOnly cookie (sent automatically via credentials).
// A non-sensitive flag in localStorage only drives UI/redirect logic.
http.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401 && localStorage.getItem("bc_admin_session")) {
      localStorage.removeItem("bc_admin_session");
      if (typeof window !== "undefined" && window.location.pathname.startsWith("/admin")) {
        window.location.assign("/admin");
      }
    }
    return Promise.reject(error);
  }
);

export async function get(path, params) {
  const { data } = await http.get(path, { params });
  return data;
}
export async function post(path, body) {
  const { data } = await http.post(path, body);
  return data;
}
export async function del(path) {
  const { data } = await http.delete(path);
  return data;
}
